<template>
  <div class="index_container">
    <common-page :type="column" />
  </div>
</template>

<script>
import CommonPage from "@/projects/simple/views/common/CommonPage.vue";

export default {
  name: "PageIndex",
  props: {
    column: String,
  },
  components: { CommonPage },
}
</script>

<style scoped lang="scss">
.index_container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>